import i18next from "i18next";

export const APP_ROUTES = {
  login: "/login",
  signUp: "/signUp",
  hours: "/hours",
  forgotPassword: "/forgotPassword",
  confirmed: "/confirmed",
  resetPassword: "/reset-password/:reset_password_token",
  setPassword: "/set-password/:reset_password_token",
  postSignup: "/thank-you",
};
export const errorMessages = {
  required: i18next.t("Field is required"),
  passwordMismatch: i18next.t("Password does not match"),
  invalidPassword: i18next.t(
    "Your password must be at least 6 characters long, contain at least one number and have a mixture of uppercase and lowercase letters."
  ),
  invalid: i18next.t("Please enter a valid value"),
  invalidEmail: i18next.t("Please enter a valid email"),
  invalidPhone: i18next.t("Please enter a valid phone number"),
  invalidNumber: i18next.t("Please enter a valid number"),
  invalidLink: i18next.t("Please enter a valid link"),
  user_exist: i18next.t("A user with this email already exists!"),
  invalidBirthID: i18next.t("Birth ID must contain 11 digits"),
  invalidBankAccountNumber: i18next.t(
    "Bank account number must contain 11 digits"
  ),
  invalidVacationDays: i18next.t("Vacation days must be less than 366 days"),
  invalidPercentage: i18next.t("Please enter value between 1 to 100"),
  invalidSalary: i18next.t("Please enter value between 1 to 999999"),
  invalidEmployees: i18next.t("Number of employees must be positive"),
  invalidLunchTime: i18next.t("Invalid lunch time will be ignored"),
  projectRestriction: i18next.t(
    "Creating, editing and deleting projects is restricted by company settings"
  ),
  projectEditRestriction: i18next.t(
    "Due to project restrictions, only color and geofence are editable."
  ),
  apiFailure: i18next.t("Something went wrong, please try again later"),
  checkExistingCompany: i18next.t(
    "That company name is already in use. Contact your admin if you need access."
  ),
  maxLength: i18next.t("Must not exceed 240 characters"),
};

export const REQUEST_LOCATION_PERMISSION_MESSAGE = `${i18next.t(
  "Your company has enabled geofence restrictions. Please grant the app access to your location to register hours."
)}`;

export const DENIED_LOCATION_PERMISSION_MESSAGE = `${i18next.t(
  "The app was unable to access your location. Please grant location access in your browser settings."
)}`;

export const ANDROID_APP_LINK =
  "https://play.google.com/store/apps/details?id=com.visualregistration.v2";
export const IPHONE_APP_LINK =
  "https://apps.apple.com/us/app/visual-registration-system/id1448200919";
export const APP_DEEP_LINK = "https://vrsv2.page.link/NLtk";

export const TABLET_STAGING_LINK = "https://stg-tablet.visualregistration.no";
export const TABLET_PRODUCTION_LINK = "https://tablet.visualregistration.no";

export const PRIVACY_POLICY_LINK = "https://www.visualregistration.com/privacy";
export const PRIVACY_POLICY_LINK_NORWEGIAN =
  "https://www.visualregistration.com/no/privacy";

export const NAVBAR = {
  BASE_WIDTH: 260,
  DASHBOARD_WIDTH: 280,
  DASHBOARD_COLLAPSE_WIDTH: 88,
  DASHBOARD_ITEM_ROOT_HEIGHT: 48,
  DASHBOARD_ITEM_SUB_HEIGHT: 40,
  DASHBOARD_ITEM_HORIZONTAL_HEIGHT: 32,
};

export const ICON = {
  NAVBAR_ITEM: 22,
  NAVBAR_SUB_ITEM: 20,
  NAVBAR_ITEM_HORIZONTAL: 20,
};

export const SYNC_STATUS = {
  not_sync: { title: i18next.t("Failed"), color: "error.main" },
  sent: { title: i18next.t("Pending"), color: "info.main" },
  sync: { title: i18next.t("Synced"), color: "success.dark" },
  not_valid: { title: i18next.t("Invalid"), color: "error.main" },
};

export const ONBOARDING_VIDEOS = {
  project: {
    thumbnail: "/project-thumbnail.png",
    url: "https://www.youtube.com/embed/iJ-AYGXOO6A?si=x6t2gmaqjGmVgu1U",
  },
  user: {
    thumbnail: "/users-thumbnail.png",
    url: "https://www.youtube.com/embed/hK3fYG83LeQ?si=qAqY8Ktsccl4EBEB",
  },
  department: {
    thumbnail: "/department-thumbnail.png",
    url: "https://www.youtube.com/embed/HLQM4VTKrWE?si=hDNAaTU5vgeiN0Bs",
  },
  planning: {
    thumbnail: "/plan-thumbnail.png",
    url: "https://www.youtube.com/embed/XvaR-VOcV_g?si=dY-1HA__bN-2LCCv",
  },
  userGroup: {
    thumbnail: "/user-group.png",
    url: "https://www.youtube.com/embed/RyZ7s8XnP7E?si=9m_sMYJCJfcPyVtw",
  },
  checkIn: {
    thumbnail: "/checkin-thumbnail.png",
    url: "https://www.youtube.com/embed/mj9CBhn7gEw?si=8F1VkJRM2W488Kga",
  },
  geofence: {
    thumbnail: "/geofence-thumbnail.png",
    url: "https://www.youtube.com/embed/M0_L6ZDLkug?si=rdPYLNqnikZedQzn",
  },
  task: {
    thumbnail: "/new-task-thumbnail.png",
    url: "https://www.youtube.com/embed/bnrK-LLvdAI?si=yuOCfI_J1-sjZXGb",
  },
};

export const PAGINATION = {
  DEFAULT_ITEMS_PER_PAGE: 100,
};

export const MODULE_NAMES = {
  DEVIANCE_AND_CATEGORY: "Non Conformities Deviance and Category",
};
